var map = {
	"./icons/activity-logs.svg": 54236,
	"./icons/admin.svg": 57712,
	"./icons/backup-now.svg": 53462,
	"./icons/calendar.svg": 42233,
	"./icons/calender-icon.svg": 64001,
	"./icons/classes.svg": 77001,
	"./icons/close-icon.svg": 36801,
	"./icons/compare.svg": 60128,
	"./icons/contacts.svg": 83596,
	"./icons/delete-icon.svg": 74940,
	"./icons/download.svg": 76887,
	"./icons/drives.svg": 99408,
	"./icons/edit.svg": 12479,
	"./icons/entra-id.svg": 72609,
	"./icons/groups.svg": 59195,
	"./icons/mail.svg": 54806,
	"./icons/overview.svg": 60850,
	"./icons/recovery-menu.svg": 68542,
	"./icons/recovery.svg": 25006,
	"./icons/refresh.svg": 71168,
	"./icons/responsive-restore-icon.svg": 6742,
	"./icons/responsive-search-icon.svg": 60652,
	"./icons/responsive-user-icon.svg": 68695,
	"./icons/search.svg": 25991,
	"./icons/seat-management.svg": 69776,
	"./icons/setting.svg": 40597,
	"./icons/user-icon.svg": 27236,
	"./icons/users.svg": 44101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87146;